import React, { ComponentPropsWithoutRef } from 'react';
import { Alert, Typography } from '@rbx/ui';

import useMarkdownAlertStyles from './MarkdownAlert.styles';

type MarkdownAlertProps = ComponentPropsWithoutRef<typeof Alert>;

export default function MarkdownAlert({ children, ...otherProps }: MarkdownAlertProps) {
  const {
    classes: { alertContainer, innerContainer },
  } = useMarkdownAlertStyles();
  return (
    <Alert className={alertContainer} {...otherProps}>
      <div className={innerContainer}>
        {typeof children === 'string' ? <Typography paragraph>{children}</Typography> : children}
      </div>
    </Alert>
  );
}
